
import React from 'react';

interface SectionContainerProps {
  children: React.ReactNode;
}

/**
 * Container component for the onboarding sections layout
 */
const SectionContainer: React.FC<SectionContainerProps> = ({
  children
}) => {
  return (
    <div className="flex flex-col lg:flex-row gap-6 pt-1">
      {children}
    </div>
  );
};

export default SectionContainer;
